export const emailRegex =
  /^(([^<>()[\]\\.,;:\s@\\"|]+(\.[^<>()[\]\\.,;:\s@\\"|]+)*)|(\\".+\\"))@(([a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,})$/i;
